// Gráfico de barras verticais simples, sem dependência externa — consistente com o resto do
// design system (tudo em CSS próprio). Cada item: { label, valor, cor? }. Por padrão assume
// valor em % (0-100); pra contagens brutas (ex: logins por dia), passe maxValor (o topo da
// escala) e sufixo="" pra não exibir o "%" depois do número.
export default function BarChart({ dados, altura = 160, corBarra = 'var(--am-amarelo-acao)', maxValor = 100, sufixo = '%' }) {
  if (dados.length === 0) return null;

  return (
    <div className="d-flex align-items-end gap-3" style={{ minHeight: altura + 50, paddingTop: 22 }}>
      {dados.map((d) => {
        const valor = Math.max(0, Math.min(maxValor, d.valor));
        const alturaBarra = Math.max(3, Math.round((valor / maxValor) * altura));
        return (
          <div
            key={d.label}
            className="d-flex flex-column align-items-center"
            style={{ flex: '1 1 0', minWidth: 0 }}
          >
            <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--am-tinta)', marginBottom: 6 }}>
              {valor}{sufixo}
            </div>
            <div
              style={{
                width: '100%',
                maxWidth: 56,
                height: altura,
                display: 'flex',
                alignItems: 'flex-end',
                background: '#f4f3ee',
                borderRadius: 8,
                overflow: 'hidden',
              }}
              title={`${d.label}: ${valor}%`}
            >
              <div
                style={{
                  width: '100%',
                  height: alturaBarra,
                  background: d.cor || corBarra,
                  borderRadius: '4px 4px 0 0',
                  transition: 'height 0.3s ease',
                }}
              />
            </div>
            <div
              style={{
                fontSize: 11,
                color: 'var(--am-cinza-texto-2)',
                marginTop: 8,
                textAlign: 'center',
                maxWidth: 84,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title={d.label}
            >
              {d.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
